import React, { useEffect, useState } from "react";
import PersonalInfo from "./PersonalInfo/PersonalInfo";
import BusinessInfo from "./PersonalInfo/BusinessInfo";
import MonitoringAddressInfo from "./AddressInfo/MonitoringAddressInfo";
import MonitoringBusinessAddressInfo from "./AddressInfo/MonitoringBusinessAddressInfo";
import AdditionalInfo from "./AdditionalInfo/AdditionalInfo";
import BusinessAdditionalInfo from "./AdditionalInfo/BusinessAdditionalInfo";
import { useSelector } from "react-redux";
import ErrorBoundary from "../../common/ErrorBoundary";
import { useAreServicesActive } from "../../../util/CommonServices";
import { idfServiceIds, ezsServiceIds } from "../../../config/UserServicesList";
import { ApplicationState } from "../../../store";
import { MonitoringData } from "../../../store/common";
import * as services from "../../../store/service";

const MonitoringInfo: React.FunctionComponent<{ monitoringData: MonitoringData }> = (props) => {
    const isPrimaryAccount = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount && state.loggedInUser.activeAccount.accountType
            ? state.loggedInUser.activeAccount.accountType.toLowerCase() === "primary"
            : false
    );
    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );
    const isLife360PartnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 539
                ? true
                : false
            : false
    );
    const [loader, setLoader] = useState(true);
    const personalInfoServices = [
        idfServiceIds.darkWebMonitoring,
        idfServiceIds.smartSSNTracker,
        idfServiceIds.smartSsnTracker,
        idfServiceIds.childCreditActivityMonitoring,
        idfServiceIds.changeOfAddressMonitoring,
        idfServiceIds.shortTermLoanMonitoring,
        ezsServiceIds.darkWebMonitoring,
        ezsServiceIds.darkWebPhiBot,
        ezsServiceIds.publicRecordsMonitoring,
        ezsServiceIds.courtRecordsMonitoring,
        ezsServiceIds.changeOfAddressMonitoring,
        ezsServiceIds.basicPublicRecordsMonitoring,
        ezsServiceIds.tuCriminalMonitoring,
        ezsServiceIds.tuIDPMonitoring,
        ezsServiceIds.paydayLoansMonitoring,
        ezsServiceIds.smartSSNTrackerAdult,
        ezsServiceIds.smartSSNTrackerChild,
        ezsServiceIds.businessDarkWebMonitoring,
        ezsServiceIds.businessHistoricalDarkWebScan,
        ezsServiceIds.tuAdvancedFraudMonitoring,
        ezsServiceIds.tuChangeOfAddressMonitoring,
        ezsServiceIds.tuSSNMonitoring,
        ezsServiceIds.tuCanadaCreditMonitoring,
        ezsServiceIds.oneBureauCreditMonitoring,
        ezsServiceIds.tuOneBureauCreditMonitoring,
        ezsServiceIds.tuOneBureauCreditMonitoringBasic,
        ezsServiceIds.tuThreeBureauCreditMonitoring,
        ezsServiceIds.tuThreeBureauCreditMonitoringBasic,
        ezsServiceIds.tuCreditLock,
        ezsServiceIds.tuCreditLockI,
        ezsServiceIds.tuCreditLock3b,
        ezsServiceIds.tuCreditLock3bI,
        ezsServiceIds.tuAnnualCreditReport,
        ezsServiceIds.tuAnnualCreditReportWithScore,
        ezsServiceIds.tuAnnualCreditScore,
        ezsServiceIds.tuDailyCreditReport,
        ezsServiceIds.tuDailyCreditReportWithScore,
        ezsServiceIds.tuDailyCreditScore,
        ezsServiceIds.tuMonthlyCreditReport,
        ezsServiceIds.tuMonthlyCreditReportWithScore,
        ezsServiceIds.tuMonthlyCreditScore,
        ezsServiceIds.tuCreditReport,
        ezsServiceIds.tuCreditReportWithScore,    
        ezsServiceIds.tuOneTimeCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditReport,
        ezsServiceIds.tuQuarterlyCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditScore,
        ezsServiceIds.tuAnnualCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCreditScoreSimulator,
        ezsServiceIds.tuCreditScoreTracker,
    ];
    const addressServices = [
        idfServiceIds.darkWebMonitoring,
        idfServiceIds.smartSSNTracker,
        idfServiceIds.smartSsnTracker,
        idfServiceIds.childCreditActivityMonitoring,
        idfServiceIds.changeOfAddressMonitoring,
        idfServiceIds.shortTermLoanMonitoring,
        ezsServiceIds.darkWebMonitoring,
        ezsServiceIds.darkWebPhiBot,
        ezsServiceIds.publicRecordsMonitoring,
        ezsServiceIds.courtRecordsMonitoring,
        ezsServiceIds.changeOfAddressMonitoring,
        ezsServiceIds.basicPublicRecordsMonitoring,
        ezsServiceIds.tuCriminalMonitoring,
        ezsServiceIds.tuIDPMonitoring,
        ezsServiceIds.sexOffenderMonitoring,
        ezsServiceIds.paydayLoansMonitoring,
        ezsServiceIds.smartSSNTrackerAdult,
        ezsServiceIds.smartSSNTrackerChild,
        ezsServiceIds.businessDarkWebMonitoring,
        ezsServiceIds.businessHistoricalDarkWebScan,
        ezsServiceIds.tuAdvancedFraudMonitoring,
        ezsServiceIds.tuChangeOfAddressMonitoring,
        ezsServiceIds.tuSSNMonitoring,
        ezsServiceIds.tuCanadaCreditMonitoring,
        ezsServiceIds.tuOneBureauCreditMonitoring,
        ezsServiceIds.oneBureauCreditMonitoring,
        ezsServiceIds.tuOneBureauCreditMonitoringBasic,
        ezsServiceIds.tuThreeBureauCreditMonitoring,
        ezsServiceIds.tuThreeBureauCreditMonitoringBasic,
        ezsServiceIds.tuCreditLock,
        ezsServiceIds.tuCreditLockI,
        ezsServiceIds.tuCreditLock3b,
        ezsServiceIds.tuCreditLock3bI,
        ezsServiceIds.tuIDPMonitoring,
        ezsServiceIds.tuAnnualCreditReport,
        ezsServiceIds.tuAnnualCreditReportWithScore,
        ezsServiceIds.tuAnnualCreditScore,
        ezsServiceIds.tuDailyCreditReport,
        ezsServiceIds.tuDailyCreditReportWithScore,
        ezsServiceIds.tuDailyCreditScore,
        ezsServiceIds.tuMonthlyCreditReport,
        ezsServiceIds.tuMonthlyCreditReportWithScore,
        ezsServiceIds.tuMonthlyCreditScore,
        ezsServiceIds.tuCreditReport,
        ezsServiceIds.tuCreditReportWithScore,    
        ezsServiceIds.tuOneTimeCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditReport,
        ezsServiceIds.tuQuarterlyCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditScore,
        ezsServiceIds.tuAnnualCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCreditScoreSimulator,
        ezsServiceIds.tuCreditScoreTracker,
    ];
    const additionalInfoFieldSerivces = [
        idfServiceIds.driversLicenseMonitoring,
        idfServiceIds.passportMonitoring,
        idfServiceIds.medicalAccountMonitoring,
        idfServiceIds.mothersMaidenNameMonitoring,
    ];

    const personalInfoFieldSerivces = [idfServiceIds.phoneNumberMonitoring, idfServiceIds.emailAddressMonitoring];
    useEffect(() => {
        if (props.monitoringData.asset) {
            setMonitoringData(props.monitoringData);
            setLoader(false);
        }
    }, [props.monitoringData]);
    const partnerProvider = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerProvider
            ? state.configurationState.configuration.partnerConfig.partnerProvider
            : "EZS"
    );
    const isAdditionalFieldServiceActive = useAreServicesActive(additionalInfoFieldSerivces);
    const isAddressActive = useAreServicesActive(addressServices);
    const isPersonalInfoActive = useAreServicesActive(personalInfoServices);
    const isDWMActive = useAreServicesActive([
        idfServiceIds.darkWebMonitoring,
        ezsServiceIds.darkWebMonitoring,
        ezsServiceIds.businessDarkWebMonitoring,
        ezsServiceIds.businessHistoricalDarkWebScan,
    ]);
    const isPhoneEmailFieldServiceActvie = useAreServicesActive(personalInfoFieldSerivces);
    const [monitoringData, setMonitoringData] = useState(props.monitoringData);
    const hidePersonalInfo = isLife360PartnerId;

    const ensureDataFetched = () => {
        services.getMonitoringAfterUpdate({ asset: { personalInfo: {} } }).then((getMonitoringResponse) => {
            setMonitoringData({ asset: getMonitoringResponse.asset });
        });
    };

    const ensureDataFetchedBusinessAdditionalInfo = () => {
        services.getMonitoring().then((getMonitoringResponse) => {
            setMonitoringData({ asset: getMonitoringResponse.asset });
        });
    };

    if (loader) {
        return (
            <div className="col-xs">
                <div className={`box offset-padding loading`}></div>
            </div>
        );
    } else {
        return (
            <>
                {
                    <div className="inherit-width">
                        <ErrorBoundary componentName="PersonalInfo" type="hideError" replaceDefaultContent={false} errorMsg="">
                            {!isBusinessUser && isPersonalInfoActive && !hidePersonalInfo && (
                                <PersonalInfo monitoringData={monitoringData} ensureDataFetch={ensureDataFetched} />
                            )}
                            {isBusinessUser && isPersonalInfoActive && <BusinessInfo monitoringData={monitoringData} ensureDataFetch={ensureDataFetched} />}
                        </ErrorBoundary>

                        <ErrorBoundary componentName="MonitoringAddressInfo" type="hideError" replaceDefaultContent={false} errorMsg="">
                            {!isBusinessUser && isAddressActive && isPrimaryAccount && !isLife360PartnerId && (
                                <MonitoringAddressInfo monitoringData={monitoringData} ensureDataFetch={ensureDataFetched} />
                            )}
                            {isBusinessUser && isAddressActive && isPrimaryAccount && (
                                <MonitoringBusinessAddressInfo monitoringData={monitoringData} ensureDataFetch={ensureDataFetched} />
                            )}
                        </ErrorBoundary>

                        <ErrorBoundary componentName="AdditionalInfo" type="hideError" replaceDefaultContent={false} errorMsg="">
                            {!isBusinessUser && (partnerProvider === "IDF" ? isDWMActive && isAdditionalFieldServiceActive : isDWMActive) && (
                                <AdditionalInfo monitoringData={props.monitoringData} />
                            )}
                            {isBusinessUser && isDWMActive && (
                                <BusinessAdditionalInfo monitoringData={monitoringData} ensureDataFetch={ensureDataFetchedBusinessAdditionalInfo} />
                            )}
                        </ErrorBoundary>
                    </div>
                }
            </>
        );
    }
};

export default MonitoringInfo;
